import React, { PureComponent } from 'react';
import { bool, func, number, object, string, node } from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { metric } from '@fiverr-private/perseus';
import GigCardCarousel from '@fiverr-private/gig_listings/src/entries/GigCardCarousel';
import contextEnrichment from '../../../utils/contextEnrichment/index';
import getGigs from '../../../utils/gigCardCarouselService';
import { getSliderConfig } from './config';

import './style.scss';

class GigCardCarouselWrapper extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            gigs: [],
            isLoading: true
        };
    }

    componentDidMount() {
        const { url, onEmptyGigs, type } = this.props;

        getGigs({ url, type })
            .then((gigs) => {
                this.setState({
                    gigs,
                    isLoading: false
                });
                this.reportFetchGigsData(false);
            })
            .catch(() => {
                this.setState({
                    isLoading: false
                });
                onEmptyGigs();
                this.reportFetchGigsData(true);
            });
    }

    reportFetchGigsData(emptyGigs) {
        const { type } = this.props;

        metric.count(`fetch_gigs_data.carousel.${type}.empty_gigs.${emptyGigs}`);
    }

    render() {
        const {
            boxTitle,
            boxClass,
            boxLocation,
            carouselPosition,
            collections,
            isLoggedIn,
            isTouch,
            updateCollections,
            source,
            carouselContext
        } = this.props;

        const {
            gigs,
            isLoading
        } = this.state;

        if (!gigs.length && !isLoading) {
            return null;
        }

        const { requestContext } = this.context;
        const { ref } = requestContext.params;

        const boxClasses = classNames('recommended-gigs', boxClass);

        const { sliderBaseNum, sliderBreakpoints } = getSliderConfig(boxLocation);

        const contextEnrichmentProps = {
            carouselPosition,
            collections,
            isLoggedIn,
            isTouch,
            updateCollections,
            source,
            carouselContext,
            ref
        };

        const enrichedContext = contextEnrichment({ ...contextEnrichmentProps, ...this.context });

        return (
            <div className={boxClasses}>
                <h2 className="section-title">{boxTitle}</h2>
                <GigCardCarousel gigs={gigs}
                    sliderBaseNum={sliderBaseNum}
                    sliderBreakpoints={sliderBreakpoints}
                    isLoading={isLoading}
                    lazyLoad={true}
                    {...enrichedContext}/>
            </div>
        );
    }
}

GigCardCarouselWrapper.propTypes = {
    boxClass: string,
    boxLocation: string,
    boxTitle: node,
    collections: object,
    isLoggedIn: bool,
    isTouch: bool,
    updateCollections: func,
    type: string,
    url: string,
    position: number,
    onEmptyGigs: func,
    source: string,
    carouselContext: string
};

GigCardCarouselWrapper.defaultProps = {
    boxLocation: 'bottom',
    isTouch: false,
    onEmptyGigs: _.noop,
    collections: {}
};

GigCardCarouselWrapper.contextTypes = {
    general: object,
    requestContext: object,
    currencyConverter: object
};

export default GigCardCarouselWrapper;
